module.exports = __webpack_public_path__ + "static/images/dumbbell-light.4715a3454a911f53ba4de20df4b81ea2.svg";